function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-compare_svg__a",
  d: "M11.625 6.243a3.501 3.501 0 017 0 3.501 3.501 0 01-7 0zm11.118 7.246l-3.735-3.73a5.21 5.21 0 001.367-3.516A5.252 5.252 0 0015.125 1a5.252 5.252 0 00-5.25 5.243 5.252 5.252 0 007.751 4.607l3.88 3.875a.873.873 0 001.237 0 .872.872 0 000-1.236zm-4.993 6.763h2.625v-1.776H17.75v1.776zm3.5-3.524h-4.375a.874.874 0 00-.875.874v3.524c0 .483.391.874.875.874h4.375a.874.874 0 00.875-.874v-3.524a.874.874 0 00-.875-.874zm-10.5 3.496h2.625V14.98H10.75v5.243zm3.5-6.99H9.875a.874.874 0 00-.875.873v6.99c0 .483.391.874.875.874h4.375a.874.874 0 00.875-.874v-6.99a.874.874 0 00-.875-.874zm-10.5 6.99h2.625V9.738H3.75v10.486zM7.25 7.99H2.875A.874.874 0 002 8.864v12.233c0 .483.391.874.875.874H7.25a.874.874 0 00.875-.874V8.864a.874.874 0 00-.875-.874z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#icon-compare_svg__a"
});

var SvgIconCompare = function SvgIconCompare(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconCompare;